<template>
    <div class="c-modal-wrapper c-has-dark-blue-header">
      <!-- Overlay loader -->
      <overlay-loader v-if="isLoading.length > 0"></overlay-loader>       
      <!-- Application Header -->
      <header class="c-modal-header">
        <div class="c-responsive-container">
          <div class="c-as-block c-has-header-buttons">
            <div class="c-grid-row">
              <div class="c-col-6 c-align-right">
                <button class="c-btn" v-on:click="cancelChanges()"><i aria-hidden="true" class="fa fa-times c-ux-color-danger"></i> <b>Otkaži</b></button>                
              </div>
              <div class="c-col-6 c-align-left">
                <button class="c-btn" v-on:click="saveChanges()"><i aria-hidden="true" class="fa fa-check c-ux-color-success"></i> <b>Sačuvaj</b></button>                
              </div>
            </div>
          </div>
        </div>
      </header>
      <!-- Body content -->
      <div class="c-modal-body c-has-skewed-background c-to-full-bottom">
        <div class="c-responsive-container">
          <form class="c-p-10" v-on:submit.prevent>
            <div class="c-info-title-labels-wrap">
              <button class="c-info-icon"><i class="fa fa-info-circle" aria-hidden="true"></i></button>
              <div class="c-info-title"><b>Kreiraj novog stalnog gosta</b></div>
            </div>            
            <!-- Name, Last name -->
            <div class="c-grid-row">
              <div class="c-col-6">
              <div class="c-form-group c-blue-style" v-bind:class="{'c-has-error' : formVars.guestFirstName.showError}">
                <label for="guest-first-name" v-if="formVars.guestFirstName.showError">{{formVars.guestFirstName.errorMsg}}</label>
                <label for="guest-first-name" v-else>Ime gosta</label>
                  <input type="text" class="c-form-control" id="guest-first-name" name="guest-first-name"
                  v-model="formVars.guestFirstName.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-last-name">Prezime gosta</label>
                  <input type="text" class="c-form-control" id="guest-last-name" name="guest-last-name"
                  v-model="formVars.guestLastName.model">
                </div>
              </div>
            </div>
            <!-- Nickname, Phone -->
            <div class="c-grid-row">
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-nickname">Nadimak</label>
                  <input type="text" class="c-form-control" id="guest-nickname" name="guest-nickname"
                  v-model="formVars.guestNickname.model">
                </div>
              </div>
              <div class="c-col-6">
                <div class="c-form-group c-blue-style">
                  <label for="guest-phone-number">Telefon</label>
                  <input type="text" class="c-form-control" id="guest-phone-number" name="guest-phone-number"
                  v-model="formVars.guestPhone.model">
                </div>
              </div>
            </div>
            <!-- Guest social link -->
            <div class="c-grid-row">
              <div class="c-form-group c-blue-style">
                <label for="guest-social-link">Link ka društvenim mrežama</label>
                <div class="c-input-group">
                  <input type="text" class="c-form-control" id="guest-social-link" name="guest-social-link"
                  v-model="formVars.guestSocialLink.model">
                  <!-- <div class="c-input-addon-wrap">
                    <button class="c-addon-item"><i class="fa fa-arrow-circle-right" aria-hidden="true"></i></button>
                  </div> -->
                </div>
              </div>
            </div>
          </form>
        </div>        
      </div>
      <!-- Application Footer Menu -->
      <!-- <footer class="c-modal-footer">
        <div class="c-responsive-container c-relative c-p-0-10">
          <div class="c-grid-row c-footer-action-buttons-wrap">
            <div class="c-col-6 c-align-right">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-success" v-on:click="saveChanges()"><i class="fa fa-check" aria-hidden="true"></i> <b>Sačuvaj</b></button>
            </div>
            <div class="c-col-6 c-align-left">
              <button class="c-btn c-btn-default c-btn-edit-mode-round-buttons c-ux-color-danger" v-on:click="cancelChanges()"><i class="fa fa-times" aria-hidden="true"></i> <b>Otkaži</b></button>
            </div>
          </div>
        </div>
      </footer> -->
    </div>
</template>

<script>
import router from '@/router/index'
import EventBus from '@/EventBus'
import OverlayLoader from "@/components/helpers/OverlayLoader";
import {firebaseDB} from '@/firebase';
export default {
  name: 'ModalCreateNewGuest',
  props: ['inputModalData'],
  components: {
      OverlayLoader: OverlayLoader
  },    
  data () {
    return {
      msg: 'ModalCreateNewGuest modal',
      visibleForAllisOn: false,
      isLoading: [1],
      formVars: {
        isValid: false,
        guestFirstName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Ime gosta je obavezno!'
        },
        guestLastName: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestNickname: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestPhone: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        },
        guestSocialLink: {
          model: null,
          inFocus: false,
          showError: false,
          //accept any character (min 2 lenght)
          //pattern: /^.{2,}$/,
          errorMsg: 'Error'
        }
      },
      resolve: null,
      reject: null
    }
  },
  watch: {
    'formVars.guestFirstName.model' : function (newValue){      
      if (this.formVars.guestFirstName.showError == true){
        this.formVars.guestFirstName.showError = false;
      }
      //console.log('formVars.eventDate.model changed to: ' + newValue);
    }
  },    
  methods: {
    // ~ When we want to save changes created on this modal
    saveChanges: function (){
      var isFormValid = this.returnNewEventFormState();
      if (isFormValid){
        this.isLoading.push(1);
        var newGuestKey = firebaseDB.ref().child('listOfRegularGuests').push().key;
        firebaseDB.ref('listOfRegularGuests').child(newGuestKey).set({
          firstName: (this.formVars.guestFirstName.model) ? this.formVars.guestFirstName.model : null,
          lastName: (this.formVars.guestLastName.model) ? this.formVars.guestLastName.model : null,
          nickname: (this.formVars.guestNickname.model) ? this.formVars.guestNickname.model : null,
          phone: (this.formVars.guestPhone.model) ? this.formVars.guestPhone.model : null,
          socialLink: (this.formVars.guestSocialLink.model) ? this.formVars.guestSocialLink.model : null,
          uid: newGuestKey
        }).then(
          function (response) {
            //console.log('Firebase Regular Guest Created succ: ' + JSON.stringify(response, null, 2));
            var resultToReturn = {
              tempMsg: 'ModalCreateNewGuest returns Yes'
            }
            this.resolve(resultToReturn);
          }.bind(this),
          function (error){
            console.log('Firebase Regular Guest Created ERROR: ' + JSON.stringify(error, null, 2));
          }.bind(this)
        );
      } 
    },
    returnNewEventFormState: function () {
      var returnValue = true;
      //
      if (!this.formVars.guestFirstName.model){
        returnValue = false;
        this.formVars.guestFirstName.showError = true;
      }
      return returnValue;
    },
    // ~ When we want to discard changes
    cancelChanges: function (){
      this.reject();
    }
  },
  created () {
    //console.log('~ created- ModalCreateNewGuest component!');
    if (this.inputModalData){
      //console.log('inputModalData: ' + JSON.stringify(this.inputModalData, null, 2) );
      this.resolve = this.inputModalData.resolve;
      this.reject = this.inputModalData.reject;
      this.isLoading.pop();
    }
  },
  mounted () {
    //console.log('~ mounted - ModalCreateNewGuest component!');
  },
  destroyed () {
    //console.log('~ destroyed- ModalCreateNewGuest component!');
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>



// WEBPACK FOOTER //
// src/components/regularGuests/ModalCreateNewGuest.vue